import { renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f41da5aa")

_pushScopeId("data-v-f41da5aa")
const _hoisted_1 = { ref: "table_filter" }
const _hoisted_2 = { class: "head_list" }
const _hoisted_3 = { class: "table_footer_fixed" }
const _hoisted_4 = { class: "results_div" }
const _hoisted_5 = { class: "fw_700 ms-3" }
const _hoisted_6 = /*#__PURE__*/_createVNode("option", { value: 15 }, "15", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("option", { value: 30 }, "30", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("option", { value: 50 }, "50", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("option", { value: 100 }, "100", -1)
const _hoisted_10 = { class: "pages_container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {
        sortBy: _ctx.localPagedRequest.sortBy,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagedRequest.sortBy = $event))
      }, undefined, true)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "backoffice_Risultati",
            text: "Risultati",
            afterText: ":"
          }),
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.totalItems), 1)
        ]),
        _createVNode("div", null, [
          _withDirectives(_createVNode("select", {
            class: "fw_700",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.localPagedRequest.paging.itemsPerPage = $event)),
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePage()))
          }, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9
          ], 544), [
            [_vModelSelect, _ctx.localPagedRequest.paging.itemsPerPage]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", {
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.subtractPage && _ctx.subtractPage(...args)))
        }, " < "),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pages, (i) => {
          return (_openBlock(), _createBlock("div", {
            key: i,
            class: {selected: _ctx.selectedPage == i},
            onClick: ($event: any) => (_ctx.setSelectedPage(i))
          }, _toDisplayString(i), 11, ["onClick"]))
        }), 128)),
        _createVNode("div", {
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addPage && _ctx.addPage(...args)))
        }, " > ")
      ])
    ])
  ], 512))
})